import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class CareerRoutesDetailHistoryItem extends BaseModel {
  static override constructorName = 'CareerRoutesDetailHistoryItem'

  author: string = ''
  text: string = ''
  link: string = ''
  image: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.image = toCroppedImage(data.image)
    }
  }
}
